<template>
  <div class="filters-filter">
    <div class="filters-filter__title">
      {{ filterObj.title[$i18n.locale] || filterObj.title.default }}
    </div>
    <ui-checkbox
      class="filters-filter__checkbox"
      :id="`filter-${f.key}`"
      v-for="f in filterObj.filters"
      :key="f.key"
      v-model="model"
      :value="f.key"
      :color="f.color"
    >
      {{ f.name[$i18n.locale] || f.name.default }}
    </ui-checkbox>
  </div>
</template>

<script>
import UiCheckbox from '@/components/UI/Checkbox.vue'

export default {
  name: 'FilterFilter',
  components: {
    UiCheckbox,
  },
  props: {
    filterObj: {
      type: Object,
      required: true,
    },
    activeFilters: {
      type: Array,
      required: true,
    },
  },
  computed: {
    model: {
      get() {
        return this.activeFilters
      },
      set(array) {
        this.$emit('update', array)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.filters-filter {
  &__title {
    @include sub-title;
  }

  &__checkbox {
    margin-bottom: 10px;
    width: 100%;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
